import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { CustomModalConfig } from './../../component/modal/custom-modal.config.interface';
import { CustomModalService } from './../../component/modal/custom-modal.service';
import { RequestService } from '../../service/api/request.service';
import { StorageService } from '../../service/storage/storage.service';
import { ShareDataService } from '../../service/share-data/share-data.service';
import { AuthGuardService } from '../../service/auth/auth-guard.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  // forgotCreatepassword: FormGroup;
  ForgotPasswordRegisterModal: CustomModalConfig;
  @Input() continueForgotpassRegisterParent : boolean;
  @Input() setting:any;
  @Output() setContinueForgotpassRegisterParent = new EventEmitter<any>();
  nextform = 0;
  user = this.storageService.getStorage('user') || [];
  email = '';
  notmail;
  phone;
  token;
  account_id = 0;
  secret_token;
  // user='';
  @Output() tokenSet = new EventEmitter<any>();
  disableNextForm1 = true;
  disableNextForm2 = true;
  disableNextForm3 = true;
  loading = false;
  patternPassErrorForm3;
  notMatchPassForm3;
  otp: string;
  otpnumber: number;
  otpErrMsg = '';
  form;
  error;
  password;
  confirmpassword
  optFillInByUser = "";
  accountPhone

  error_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'minlength', message: 'Email length.' },
      { type: 'maxlength', message: 'Email length.' },
      { type: 'required', message: 'please enter a valid email address.' }
    ],
    'password': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'password length.' },
      { type: 'maxlength', message: 'password length.' }
    ],
    'confirmpassword': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'password length.' },
      { type: 'maxlength', message: 'password length.' }
    ],
  }

  constructor(
    private requestService : RequestService,
    private customModalService: CustomModalService,
    private storageService : StorageService,
    private shareDataService: ShareDataService
  ) {
    this.ForgotPasswordRegisterModal = {
      title: 'Forgot password/Register',
      content: '',
      type: 'primary',
      backdrop: 'static',
    }
  }

  ngOnInit(){
    let account_detail = this.setting['setting']['account_detail'];
    if(account_detail && account_detail.length > 0){
      this.accountPhone = (account_detail[0]['tracking_phone'] ? account_detail[0]['tracking_phone'] : (account_detail[0]['phone'] ? account_detail[0]['phone'] : account_detail[0]['phone2']));
      this.account_id= account_detail[0]['account_id'];
    }
  }

  ngOnChanges() {
    if(this.continueForgotpassRegisterParent){
      this.loading = false;
      this.disableNextForm1 = true;
      this.customModalService.open('forgotpassword-register-modal');
    }
  }

  cancelForgotpasswordRegister() {    
    this.setContinueForgotpassRegisterParent.emit(false);
    this.customModalService.close('forgotpassword-register-modal');
    this.nextform = 0;
    this.email = '';
    this.error = '';
    this.otpErrMsg = '';
    this.otpnumber = 0;
    this.disableNextForm1 = true;
    this.disableNextForm2 = true;
    this.disableNextForm3 = true;
  }

  checkNext(action=''){
    if(action == 'close'){
      this.updatepassword(this.email,this.password) 
      this.disableNextForm1 = true;
      this.nextform = 0;
      this.customModalService.close('forgotpassword-register-modal')
      this.email = '';
    }else if(this.otpnumber !== undefined){
      this.nextform = 1
    }else if(action='otp'){
      this.nextform = 2
    }
    else if(action == 'newpass'){
      this.onOtpChange(this.optFillInByUser);
      //this.updatepassword(this.email,this.password) 
    }else{
      this.notmail=true;
    }
  }

  async checkForm1(event) {
    let validateEmail = this.validateEmail(this.email);
    this.error = '';
    if (this.email !== '' && validateEmail) {
        if(this.email !== ''){
          this.disableNextForm1 = false; // active btn form 1
        }
        if(event.code=='Enter' || event=='click'){   // when set can enter use => //if(event.code=='Enter' || event=='click')
          this.disableNextForm1 = true;          
          this.loading = true; //show spinner loading
          let parentApi =  this.requestService.getParentAPI();
          let body = {
            "email" : this.email,
            'acc_id': this.account_id
          };
          try {
            let result = await parentApi.post(parentApi.route.checkEmailVerify, body, {});          
              if(result){
                this.error == "";
                this.token = result['token'];           
                if(result['token']){
                  let optionsHeader = {
                      headers: {
                          'Authorization': 'Bearer ' + this.token,
                          '_ath': 0
                        }
                      }
                  let body = {
                      "operationName": "parentGlobalSelect",
                      "query": "query parentGlobalSelect($email: String!) {  parentGlobalSelect(email: $email) {   phone    __typename  }}",
                      "variables": {
                      "email": this.email
                      }
                  };
                  if(!this.otpnumber){
                    try {
                        let resultgql = await parentApi.post(parentApi.route.graphql, body, optionsHeader);
                        if(resultgql['data']['parentGlobalSelect']['phone']){
                            this.phone = await resultgql['data']['parentGlobalSelect']['phone'];
                            if(this.phone !== undefined){
                              await this.genOTP(this.phone);
                            this.disableNextForm1 = false; // active btn form 1
                            this.loading = false; //hide spinner loading
                            this.checkNext();
                            this.error = '';
                            }
                        }
                      }catch (error) {
                        let status = error.data?.status;
                      }
                }
                }else{
                  this.error = "nottoken";
                  this.disableNextForm1 = false; // disable btn form 1
                  this.loading = false;
                  this.email = ''
                }
              }else{
                this.loading = false; //hide spinner loading
                this.nextform = 0;
                this.disableNextForm1 = true; // disable btn form 1
              }
          } catch(error) {
            this.loading = false; //hide spinner loading
            this.nextform = 0;
            this.disableNextForm1 = false; //active btn form 1
            this.error = "fail";
            console.log("SendSMS Error ==> ",error);
          } finally {
            console.log("checkForm1 is complete");
          }
        if(!this.error){
          this.disableNextForm1 = false; // active btn form 1
        }else{
          if(event.code=='Enter'){
            this.disableNextForm1 = true; // disable btn form 1
          }
        }
      }
        
    } else {
      this.disableNextForm1 = true; // disable btn form 1
    }
  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  
  validatePassword(password){
  const regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&+-.])[A-Za-z\d@$!%*#?&+-.]{14,}$/;
  return regularExpression.test(String(password));
}

  async genOTP(phoneNumber){
    this.otpnumber = Math.floor(100000 + Math.random() * 900000);
    // console.log("OTP Number is: ",this.otpnumber);
    let parentApi =  this.requestService.getParentAPI();
    let optionsHeader = {
      headers: {
          'Authorization': 'Bearer ' + this.token,
          '_ath': 0
        }
      }
    let body = {
                  type: 'PRP'
               }
    try {
      let res = await parentApi.post(parentApi.route.sendOTP, body, optionsHeader); // SendSMS Request
      // console.log("SendSMS Response ==> ",res);
      if(res['code'] == 1){
        this.secret_token = res['secret_user'];
      }
    }catch(error){
      console.log("SendSMS Error ==> ",error);
    };
  }

  async onOtpChange(otp) {
    if(otp){
      this.optFillInByUser = otp;
      if(otp.length == 6){
        let parentApi =  this.requestService.getParentAPI();
        let optionsHeader = {
          headers: {
              'Authorization': 'Bearer ' + this.secret_token,
              '_ath': 0
            }
          }
        let body = {
                      otp: otp,
                      secret_user: this.secret_token
                   }
        try {
          let res = await parentApi.post(parentApi.route.verifyOtp, body, optionsHeader); // Verify OTP
          // console.log("Verify OTP Response ==> ",res);
          if(res['code'] == 1){
            this.disableNextForm2 = false; // active btn form 
            this.otpErrMsg = '';
            this.nextform = this.nextform+1
            this.token = res['token']
          }else if(res['code'] == 0){
              this.disableNextForm2 = true; // active btn form 2
              this.otpErrMsg = 'OTP is not a valid';
          }
        }catch(error){
          console.log("Verify OTP Error ==> ",error);
        };
      }
    }
  }
  
  async checkForm3(event) {
    let validatePassword = this.validatePassword(this.password);
    if(!validatePassword){
      this.patternPassErrorForm3 = "password is not a valid pattern";
    }else{
      this.patternPassErrorForm3 = "";
    }
    if (validatePassword && this.password === this.confirmpassword && (this.password != "") && (this.confirmpassword != "")){
      this.disableNextForm3 = false; // active btn form 3
      this.notMatchPassForm3 = "";
      if(event.code=='Enter'){
        await this.updatepassword(this.email,this.password)
      }
    } else {
      this.disableNextForm3 = true; // disable btn form 3
      
      this.notMatchPassForm3 = "confirm password does not match";
    }
  }

  async updatepassword(email,password){
    let parentApi =  this.requestService.getParentAPI();
    let optionsHeader = {
      headers: {
          'Authorization': 'Bearer ' + this.token,
          '_ath': 0
        }
      }
    let body = {
                "operationName": "parentPasswordUpdate",
                "variables": {
                  "input": {
                    "email": email,
                    "password": password
                  }
                },
                "query": "mutation parentPasswordUpdate($input: UpdatePasswordInput!) {\n  parentPasswordUpdate(input: $input) {\n    msg\n    status\n    __typename\n  }\n}\n"
              }
    try {
      // Request Update Password
      let resUpdate = await parentApi.post(parentApi.route.graphql, body, optionsHeader);
      
      if(resUpdate['data'].parentPasswordUpdate.status){
        let requestBody = parentApi.routeOption.login;
        requestBody.username = email;
        requestBody.password = password;

        // Set Auto login with new Password
        let resAutoLogin = await parentApi.post(parentApi.route.login,requestBody,{})
        if(resAutoLogin['token'] && resAutoLogin['user']['id']){
          await this.storageService.setStorage('user',JSON.stringify(resAutoLogin));
          this.user = await this.storageService.getStorage('user');
          this.tokenSet.emit(this.user);
    
          let msg = JSON.stringify({
            event: AuthGuardService.EVENT.LOGIN_SUCCESS,
          })
          this.shareDataService.changeMessage(msg)
        }
      }
    }catch(error){
      let status = error.message.response.status
        let statusText = error.message.response.statusText
        console.log('login component userlogin err => ',status, error); // get error for check login => status, ex
        let msg = JSON.stringify({
          event: AuthGuardService.EVENT.LOGIN_ERROR,
          data: {
            status: status,
            success: false,
            statusText: statusText
          }
        })
        this.shareDataService.changeMessage(msg)
    
    };


  }

}
